import { FC } from 'react';
import { useSelector } from 'react-redux';

import { themeDark } from 'shared/utils/cssUtility';
import { Text } from '../Text';
import { ChargeIcon, ExternalIcon } from '../Icons';
import { BackButton } from '../Buttons';
import { getAppConfigSelector } from 'store/app/app.redux';
import { classNames } from 'shared/utils/class-names';

import classes from './styles.module.scss';

export interface IPageHeader {
  title: string;
  description?: string;
  hasBackBtn?: boolean;
  linkDescription?: string;
  linkHref?: string;
  needRel?: boolean;
}

const PageHeader: FC<IPageHeader> = ({
  title,
  description,
  hasBackBtn = false,
  linkDescription,
  linkHref,
  needRel = true
}) => {
  const appConfig = useSelector(getAppConfigSelector);

  return (
    <div className={classes.header}>
      <div className={classNames(classes.header_top, 'header-page')}>
        <div>
          <Text
            className={classes.titleWithIcon}
            type={'sf-caption-emphasized'}
            color={'text-secondary'}
            upperCase
          >
            <ChargeIcon color="#A3ACBA" width={12} height={12} />
            {appConfig.logoWithName ? (
              <img
                src={appConfig.logo as string}
                alt={`${appConfig.appName} Logo`}
                className={classNames(
                  classes.page_header_logo,
                  'page-header-logo'
                )}
              />
            ) : (
              appConfig.appName
            )}
          </Text>
          <Text
            type={'m-section-bold'}
            color={'text-primary'}
            className="title-weight"
          >
            {title}
          </Text>
        </div>
        {hasBackBtn && <BackButton />}
      </div>
      <Text type={'sf-body'} color={'text-secondary'}>
        {description}
      </Text>
      {linkDescription && (
        <Text
          target="_blank"
          rel={needRel ? 'noopener noreferrer' : null}
          component={'a'}
          type={'m-body-emphasized'}
          href={linkHref}
          className={classes.titleWithIcon}
          color={'theme-dark'}
        >
          {linkDescription}
          <ExternalIcon color={themeDark} width={12} height={12} />
        </Text>
      )}
    </div>
  );
};

export default PageHeader;
